import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DrawingManager as GMapDrawingManager } from '@react-google-maps/api';
import Drawing from './drawing';
import { circleOptions, polygonOptions, removeMapObjects } from '../../app/google_maps';
import NotificationsHelper from '../../app/notifications_helper';

export default class DrawingManager extends Component {
  constructor(props) {
    super(props);
    this.state = { drawing: false };
    if (props.selected) { this.subscribeUIEvents(); }

    this.onOverlayComplete = this.onOverlayComplete.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.selected) {
      const eventName = `click.${this.props.idPrefix}${this.props.object.id}`;
      this.element('circle').off(eventName);
      this.element('draw_polygon').off(eventName);
      this.removeShape();
      return;
    }

    this.subscribeUIEvents();
  }

  componentWillUnmount() {
    const eventName = `click.${this.props.idPrefix}${this.props.object.id}`;
    this.removeShape();
    this.element('circle').off(eventName);
    this.element('draw_polygon').off(eventName);
  }

  onOverlayComplete({ overlay, type }) {
    this.shape = overlay;

    const points = overlay.getPath().getArray();
    if (points.length <= 2) {
      NotificationsHelper.notify(I18n.t('extras.drawing.polygon_min_vertices'), '', 'warning');
      this.removeShape();
      this.setState({ drawing: false, drawingMode: null });
      return;
    }

    const bounds = _.reduce(points,
      (result, point) => result.extend(point),
      new google.maps.LatLngBounds());
    const center = bounds.getCenter();

    // Save object
    this.element('region').val('polygon');
    this.element('polygon_as_json').val(JSON.stringify({
      type,
      center,
      paths: overlay.getPath().getArray(),
    }));
    if (this.element('draw_polygon').data('auto-submit')) {
      this.element('region').parents('form').submit();
    }

    // Reset drawing mode
    this.removeShape();
    this.setState({ drawing: false, drawingMode: null });
  }

  element(id) {
    return $(`#${this.props.idPrefix}_${id}`);
  }

  subscribeUIEvents() {
    const eventName = `click.${this.props.idPrefix}${this.props.object.id}`;

    this.element('circle').off(eventName).on(eventName, ({ currentTarget }) => {
      const $circleButton = $(currentTarget);
      if ($circleButton.hasClass('active')) { return; }

      this.element('draw_polygon').removeClass('active');
      $circleButton.addClass('active');

      this.removeShape();
      this.setState({ drawing: false, drawingMode: null });

      this.element('region').val('circle');
      this.element('polygon_as_json').val('{}');

      if ($circleButton.data('auto-submit')) {
        $circleButton.parents('form').submit();
      }
    });

    this.element('draw_polygon').off(eventName).on(eventName, ({ currentTarget }) => {
      this.element('circle').removeClass('active');
      this.element('radius').attr('disabled', 'disabled');
      this.element('radius').rangeslider('update', true);

      $(currentTarget).addClass('active');
      this.removeShape();
      this.setState({ drawing: true, drawingMode: google.maps.drawing.OverlayType.POLYGON });
    });
  }

  removeShape() {
    if (!this.shape) { return; }
    removeMapObjects(this.shape);
    this.shape = null;
  }

  drawing() {
    if (!this.props.selected || this.state.drawing) { return null; }
    const $coordinates = this.element('coordinates');
    const polygon = _.attempt(() => JSON.parse(this.element('polygon_as_json').val()).paths);
    return (
      <Drawing
        position={{ lat: parseFloat($coordinates.data('lat')), lng: parseFloat($coordinates.data('lng')) }}
        radius={parseInt(this.element('radius').val(), 10)}
        polygon={_.isError(polygon) ? null : polygon}
        region={this.element('region').val()}
      />);
  }

  drawingManager() {
    if (!this.props.selected || !this.state.drawing) { return null; }
    return (
      <GMapDrawingManager
        drawingMode={this.state.drawingMode}
        onOverlayComplete={this.onOverlayComplete}
        options={{
          drawingControl: false,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
              google.maps.drawing.OverlayType.CIRCLE,
              google.maps.drawing.OverlayType.POLYGON,
            ],
          },
          circleOptions: _.extend({
            clickable: true,
            editable: true,
            draggable: true,
          }, circleOptions),
          polygonOptions: _.extend({
            clickable: true,
            editable: true,
            draggable: true,
          }, polygonOptions),
        }}
      />);
  }

  render() {
    return (
      <div>
        {this.drawing()}
        {this.drawingManager()}
      </div>
    );
  }
}

DrawingManager.propTypes = {
  selected: PropTypes.bool.isRequired,
  idPrefix: PropTypes.string.isRequired,
  object: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};
